var Buf = require('buf');
var Member = require('member');
var User = require('user');
var Keyboard = require('../lib/keyboard.es6').default;
var util = require('../lib/util.es6');


var TabCompletion = Backbone.View.extend({
    initialize: function (options) {
        this.clear();
        this.emoji = null;
        this.candidate = 0;
        this.throttledCursorCandidates = _.throttle(_.bind(this.cursorCandidates, this), 60);
    },
    events: {
        'input': 'onInput',
        'keyup': 'onInput',
        'update': 'onInput'
    },
    clear: function () {
        this.word = null;
        this.trail = null;
        this.prev = null;
        this.original = false;
        this.cyclingBlank = false;
        this.cyclingCommand = false;
        this.cyclingBlankCommand = false;
        this.cyclingBlankJoin = false;
        this.cyclingModes = false;
        this.candidateIsChan = false;
        this.candidateIsUser = false;
        this.cyclingTopic = false;
        this.cyclingJoin = false;
        this.cyclingLastHighlighted = false;
        this.cyclingBan = false;
    },
    clearAll: function () {
        this.clear();
        this.emoji = null;
    },
    cursorCandidates: function () {
        if (!this.cyclingTopic) {
            // Setup state again
            this.resetGetCandidates();
            this.candidates = this.getEmojiCandidates();
            this.trigger('completeCandidates', this.word, this.candidates, undefined, this.emoji);
        }
        // Clean up state again
        this.clear();
    },
    onInput: function (e) {
        var value = $(this.el).val();
        if (value != this.getValue()) {
            this.value = value;
            this.throttledCursorCandidates();
        }
    },
    makeClickedChoice: function (index) {
        this.makeChoice(index);
        this.clearAll();
    },
    makeChoice: function (index, options) {
        var choice = this.chooseCandidate(index, options);
        this.updateInput(choice);
    },
    makeOriginalChoice: function () {
        var choice = this.chooseOriginal();
        this.updateInput(choice);
    },
    onKey: function (e) {
        if (e.ctrlKey || e.altKey || e.metaKey) {
            return;
        }

        var cr = $(this.el).cursorRange();
        if (!this.cursorRange) {
            this.cursorRange = cr;
        }
        if (e.which === Keyboard.KEYS.TAB) {
            e.preventDefault();
            if (this.cursorRange.start === this.cursorRange.end) {
                // Don't complete when we have selected text
                var reverse = e.shiftKey;
                this.updateIndex(reverse);
                this.candidates = this.getCandidates();
                var index = this.getIndex();
                if (!this.cyclingTopic) {
                    this.trigger('completeCandidates', this.word, this.candidates, index);
                }
                var options = {};
                var nextChar = this.trail[0] || this.afterSelection[0];
                var prevChar = this.prev[this.prev.length-1];
                if (prevChar !== '@' && this.model.connection.isSlack()) {
                    options.atMention = true;
                }
                if (nextChar === ':' || nextChar === ' ') {
                    options.separator = '';
                    options.nospace = true;
                    options.emojiColonAfter = (nextChar === ':');
                }
                this.makeChoice(index, options);
            }
        } else if (!e.shiftKey && e.which !== Keyboard.KEYS.ESC) {
            // Keypress can move the cursor position, so let's check candidates
            // again (since emoji completions show and hide without pressing tab)
            // Skip if shift is being pressed (e.g. shift arrow selection)
            // Skip if escape was pressed, to allow emoji candidates to be dismissed
            this.throttledCursorCandidates();
        }
    },
    chooseOriginal: function () {
        // Reset the word and return to just the word on its own
        var choice = this.cyclingBlank ? '' : this.word;
        this.clearAll();
        return choice;
    },
    cmpBuffers: function (a, b) {
        // 1. Badged/unread
        var unseen = (b.hasUnseen() && b.isTrackingUnread()) -
                     (a.hasUnseen() && a.isTrackingUnread());
        if (unseen !== 0) {
            return unseen;
        }
        // 2. Last selected
        var time = (b.lastSelected || 0) - (a.lastSelected || 0);
        if (time !== 0) {
            return time;
        }
        // 3. Currently selected, active, unarchived
        var state = (b.isSelected() - a.isSelected()) ||
                    (b.isActive()   - a.isActive())   ||
                    ((a.isServerLog() || a.isArchived()) -
                     (b.isServerLog() || b.isArchived()));
        if (state !== 0) {
            return state;
        }
        // 4. Connection
        if (a.getCid() > b.getCid()) {
            return 1;
        } else if (a.getCid() < b.getCid()) {
            return -1;
        //  5. Deprioritise server logs
        } else if (a.isServerLog() && !b.isServerLog()) {
            return 1;
        } else if (b.isServerLog() && !a.isServerLog()) {
            return -1;
        } else {
            // 5. alpha

            var aName = a.isServerLog() ? a.getFullLabel() : a.getName();
            var bName = b.isServerLog() ? b.getFullLabel() : b.getName();
            if (aName > bName) {
                return 1;
            } else if (aName < bName) {
                return -1;
            } else {
                return 0;
            }
        }
    },
    cmpAll: function (a, b) {
        // 1. Last highlighted, last spoke
        var time;
        var aLastHighlight, bLastHighlight, aLastSpoke, bLastSpoke;
        if (a instanceof Member) {
            aLastSpoke = a.getLastSpoke();
            aLastHighlight = a.getLastHighlighted();
        }
        if (b instanceof Member) {
            bLastSpoke = b.getLastSpoke();
            bLastHighlight = b.getLastHighlighted();
        }
        time = (bLastHighlight || 0) - (aLastHighlight || 0) ||
               (bLastSpoke     || 0) - (aLastSpoke     || 0);
        if (time) {
            return time;
        }

        if (a instanceof User || b instanceof User) {
            if (a instanceof Buf) {
                return -1;
            } else if (b instanceof Buf) {
                return 1;
            } else {
                return util.naturalCompare(a.normalise(), b.normalise());
            }
        }

        // Only buffers should get here
        if (a instanceof Buf || b instanceof Buf) {
            return this.cmpBuffers(a, b);
        } else {
            return this.cmpString(a, b);
        }
    },
    cmpString: function (a, b) {
        if (a > b) {
            return 1;
        } else if (b < a) {
            return -1;
        } else {
            return 0;
        }
    },
    cursorRangeChange: function () {
        var cr = $(this.el).cursorRange();
        return !this.cursorRange || cr.start != this.cursorRange.start || cr.end != this.cursorRange.end;
    },
    cacheCursorRange: function () {
        this.cursorRange = $(this.el).cursorRange();
    },
    getValue: function () {
        return this.value || '';
    },
    updateIndex: function (reverse) {
        // Initial setup
        if (!this.word && !this.cyclingBlank) {
            if (reverse) {
                this.candidate = -1;
            } else {
                this.candidate = 0;
            }
        } else {
            // Move the candidate index on, so we cycle through the choices
            if (reverse) {
                if (this.candidate === 0) {
                    // This indicates we were going forwards and are now going backwards and have reached the start
                    this.original = true;
                }
                this.candidate--;
            } else {
                this.candidate++;
            }
        }
    },
    inputMatchesNoStrip: function (candidate, input) {
        return this.inputMatches(candidate, input, true);
    },
    inputMatches: function (candidate, input, noStrip) {
        if (!candidate) {
            return false;
        }
        // normalise case
        candidate = candidate.toLowerCase();
        input = input.toLowerCase();

        // Just use the last word
        var inputTokens = input.split(/\s+/);
        var lastInput = inputTokens.pop();

        // Strip leading non alphanum chars from candidate unless input starts with one
        if (!noStrip && lastInput.match(/^[a-z0-9]/)) {
            candidate = candidate.replace(/^[^a-z0-9]+/, '');
        }

        return candidate.indexOf(lastInput) === 0;
    },
    splitWords: function (words) {
        // Match words
        return words.match(TabCompletion.WORD_REGEX) || [];
    },
    getWordPrevTrail: function (words) {
        var tokens = this.splitWords(words);
        var word = tokens.pop() || '';
        var index = words.lastIndexOf(word);
        var prev = words.slice(0, index);
        var trail = words.slice(index + word.length);
        return [word, prev, trail];
    },
    splitCursorWordValues: function () {
        this.cacheCursorRange();
        // Split the sentence either side of the word before the selection
        var value = this.getValue();
        this.wordsTillSelection = value.slice(0, this.cursorRange.start);
        this.afterSelection = value.slice(this.cursorRange.start);
        var wordPrevTrail = this.getWordPrevTrail(this.wordsTillSelection);
        this.word = wordPrevTrail[0];
        this.prev = wordPrevTrail[1];
        this.trail = wordPrevTrail[2];
    },
    getEmojiCandidates: function (candidates) {
        candidates = candidates || [];
        if (this.word[0] === ':') {
            var emoWord = this.word.replace(/^:/, '').replace(/_/g, '');
            if (emoWord.length > 1) {
                var emoCandList = util.matchEmoji(emoWord);
                if (emoCandList && emoCandList.length) {
                    this.emoji = this.word;
                    var skinTone = this.model.session.getPref('skin-tone');
                    _.each(emoCandList, function emojiCandListEach (cand) {
                        candidates.push({
                            emoji: cand.idx,
                            title: emoji.strip_colons_only(
                                emoji.idx_to_colon(cand.idx, skinTone)
                            ),
                            skinTone: skinTone,
                            getName: function () {
                                return cand.idx;
                            }
                        });
                    });
                }
            }
        }
        return candidates;
    },
    resetGetCandidates: function () {
        this.emoji = null;
        if (!this.word && !this.cyclingBlank) {
            this.splitCursorWordValues();
        }
    },
    getCandidates: function (emoji) {
        this.resetGetCandidates();

        var members = this.model.getMembers();
        var channels = this.model.connection.buffers.channels;
        var previousBuffer = this.model.session.previousBuffer;

        // Build up list of matching candidates
        var candidates = [];
        
        var command;
        var chanCommand = false;
        var banCommand = false;
        var topicCommand = false;
        var nonJoinOnlyChans = false;

        var commandMatch = this.wordsTillSelection.match(/^\/(\w+)(\s+.*|$)/);
        if (commandMatch) {
            command = commandMatch[1].toLowerCase();
            this.cyclingCommand = command;
            if (commandMatch[2].match(/^\s*$/)) {
                this.cyclingBlank = true;
                this.cyclingBlankCommand = true;
            }
            switch (command) {
            case 'j':
            case 'join':
            case 'channel':
            case 'rejoin':
            case 'mode':
                chanCommand = true;
                if (command == 'mode') {
                    this.cyclingModes = true;
                    if (this.cyclingBlankCommand) {
                        nonJoinOnlyChans = true;
                    }
                } else {
                    this.cyclingJoin = true;
                    if (this.cyclingBlankCommand) {
                        this.cyclingBlankJoin = true;
                    }
                }
                break;
            case 'ban':
                banCommand = true;
                break;
            case 'topic':
                topicCommand = true;
                break;
            }
        }
        if (this.cyclingBlankCommand && chanCommand) {
            // Channel command, only complete from channels
            channels.each(function getCandidatesEachChannelCommand (channel) {
                if (!channel.isArchived()) {
                    candidates.push(channel);
                }
            });

            candidates.sort(this.cmpBuffers);
        } else if (this.model.isChannel() && this.cyclingBlankCommand && topicCommand && this.model.getTopic()) {
            // Cycle topics
            var topic = this.model.getTopic().getText();
            this.cyclingTopic = true;
            // TODO keep a history of topics server side
            candidates.push(topic);
        } else if (!this.word) {
            // No word, only complete from last highlighted (or conversation recipient)
            this.cyclingBlank = true;
            this.cyclingLastHighlighted = true;
            if (this.model.isConversation()) {
                candidates.push(this.model.getRecipient());
            } else {
                members.each(function getCandidatesEachMember (member) {
                    if (!member.isIgnored() && (
                        // Either thread participant or highlighter
                        this.model.isThread() || member.lastHighlighted
                    )) {
                        candidates.push(member);
                    }
                }, this);
            }

            // Sort by last highlighted
            candidates.sort(function getCandidatesSort (a, b) {
                return (b.getLastHighlighted() || 0) - (a.getLastHighlighted() || 0);
            });
        } else {
            // Have a word, not a channel command, add matching members, channels and emoji
            var anyMembers = false;
            var getCandidatesEachMemberWord = function (member) {
                if (
                    this.inputMatches(member.getName(), this.word) ||
                    this.inputMatches(member.getDisplayAuthor(), this.word)
                ) {
                    anyMembers = true;
                    candidates.push(member);
                }
            };
            if (this.model.isThread()) {
                this.model.buffer.getMembers().each(getCandidatesEachMemberWord, this);
            } else {
                members.each(getCandidatesEachMemberWord, this);
            }

            if (!banCommand) {
                channels.each(function getCandidatesEachChannelWord (chan) {
                    if (this.inputMatchesNoStrip(chan.getName(), this.word)) {
                        if (!anyMembers) {
                            nonJoinOnlyChans = true;
                        }
                        candidates.push(chan);
                    }
                }, this);
            }
            candidates.sort(_.bind(this.cmpAll, this));

            // Emoji
            candidates = this.getEmojiCandidates(candidates);
        }

        // Move previous chan to start for join commands
        if (chanCommand && previousBuffer && previousBuffer.isChannel()) {
            var prevChanIndex = $.inArray(previousBuffer, candidates);
            if (prevChanIndex !== -1) {
                var prevChan = candidates.splice(prevChanIndex, 1)[0];
                candidates.unshift(prevChan);
            }
        }

        if (!this.cyclingTopic) {
            var selfIndex = _.indexOf(_.map(candidates, function getCandidatesNormaliseSelf (item, index) {
                return item.getName().toLowerCase();
            }), this.model.getNick().toLowerCase());
            if (selfIndex !== -1) {
                var selfItem = candidates.splice(selfIndex, 1)[0];
                if (this.cyclingModes && this.cyclingBlankCommand) {
                    // Move yourself to the start for modes
                    candidates.unshift(selfItem);
                } else {
                    // Move yourself to the end
                    candidates.push(selfItem);
                }
            } else if (this.cyclingModes && this.cyclingBlankCommand) {
                // Insert yourself at the start for modes
                candidates.unshift(this.model.connection.getUser());
            }
        }

        var selfChanIndex = $.inArray(this.model, candidates);
        if (selfChanIndex !== -1) {
            // Move current chan to end for join commands and to start for other chan only commands
            var selfChan = candidates.splice(selfChanIndex, 1)[0];
            if (nonJoinOnlyChans) {
                candidates.unshift(selfChan);
            } else {
                candidates.push(selfChan);
            }
        }

        if (banCommand) {
            this.cyclingBan = true;
            // Add a ban mask too
            candidates = _.flatten(_.map(candidates, function getCandidatesAddBanMask (m) {
                return [m, m.getBanMask(true)];
            }));
        }

        return candidates;
    },
    getIndex: function () {
        if (this.original) {
            return -1;
        }
        var index = this.candidate;
        if (index < 0) {
            index = this.candidates.length + index;
        }
        return index;
    },
    chooseCandidate: function (index, options) {
        options = options || {};
        if (!this.candidates[index]) {
            // We've overflown the candidates array
            return this.chooseOriginal();
        }

        var choice = this.candidates[index];
        if (choice instanceof Backbone.Model) {
            this.candidateIsChan = (choice instanceof Buf && choice.isChannel());
            this.candidateIsUser = choice instanceof User;
            choice = choice.getName();
        } else if (choice.emoji) {
            var emojiValue = '';
            emojiValue += ':';
            emojiValue += choice.title;
            if (!options.emojiColonAfter) {
                emojiValue += ':';
            }
            choice = emojiValue;
        }
        if (this.candidateIsUser && options.atMention && (
            !this.cyclingCommand || this.cyclingCommand == 'me'
        )) {
            // Always add an at sign when needed
            choice = '@' + choice;
        } else {
            if (options.separator !== undefined) {
                // Allow separator override
                choice += options.separator;
            } else if (this.candidateIsUser && this.word === this.wordsTillSelection) {
                // Add separator if it's the first word of the line and a user mention
                choice += ':';
            }
        }
        // Add a spacer if choice is:
        if (
            !options.nospace &&
            // * not emoji — :lol:
            !this.emoji &&
            // * not topic — /topic+tab
            !this.cyclingTopic &&
            // * not join command on its own — /j+tab
            !this.cyclingBlankJoin
        ) {
            choice += ' ';
        }
        return choice;
    },
    updateInput: function (choice) {
        // Update the input box value
        var beforeSelection;
        if (this.word && !this.cyclingBlank) {
            beforeSelection = this.wordsTillSelection.slice(0, this.wordsTillSelection.lastIndexOf(this.word));
        } else if (this.emoji && !this.cyclingBlank) {
            beforeSelection = this.wordsTillSelection.slice(0, this.wordsTillSelection.lastIndexOf(this.emoji));
        } else {
            beforeSelection = this.wordsTillSelection;
        }
        if (this.word && !this.word.match(/\s+$/) && this.cyclingBlankCommand) {
            beforeSelection += ' ';
        }
        var cursorStart = beforeSelection.length;
        var cursorEnd;
        if (this.word || this.emoji || this.cyclingBlank) {
            beforeSelection += choice;
        }
        this.value = beforeSelection;
        if (this.word) {
            this.value += this.trail;
        }
        this.value += this.afterSelection;
        $(this.el).val(this.value);

        // Move the cursor to after the choice
        if (this.candidateIsChan && this.cyclingJoin) {
            // Select the channel name if it's a channel
            cursorStart++;
            cursorEnd = beforeSelection.length;
        } else {
            // Don't set cursorEnd for mode channels or non channels
            cursorStart = beforeSelection.length;
        }
        $(this.el).cursorRange(cursorStart, cursorEnd);
    }
}, {
    WORD_REGEX: new RegExp('[' +
        // alnum
        'a-z0-9' +
        // Latin
        '\\u00C0-\\u00D6'   +
        '\\u00D8-\\u00F6'   +
        '\\u00F8-\\u02AF'   +
        // Greek
        '\\u0370-\\u03ff'   +
        // CJK
        // http://en.wikipedia.org/wiki/Hangul
        // http://en.wikipedia.org/wiki/Hiragana
        // http://en.wikipedia.org/wiki/Katakana
        // http://en.wikipedia.org/wiki/Han_unification#Unicode_ranges
        '\\uAC00-\\uD7AF'   + // (K)   Hangul Syllables
        '\\u1100-\\u11FF'   + // (K)   Hangul Jamo
        '\\u3130-\\u318F'   + // (K)   Hangul Compat Jamo
        '\\uA960-\\uA97F'   + // (K)   Hangul Jamo Ext A
        '\\uD7B0-\\uD7FF'   + // (K)   Hangul Jamo Ext B
        '\\u3040-\\u309F'   + // (J)   Hiragana
        '\\u30A0-\\u30FF'   + // (J)   Katakana
        '\\u31F0-\\u32FF'   + // (J)   Katakana Phonetic
        // '\\u1B000-\\u1B0FF' + // (J)   Kana Suppl
        '\\uFF00-\\uFFEF'   + // (KJ)  Half/Full Forms
        '\\u4E00-\\u9FFF'   + // (CJK) Unified
        '\\u3400-\\u4DBF'   + // (CJK) Ext A
        // '\\u20000-\\u2A6DF' + // (CJK) Ext B
        // '\\u2A700-\\u2B73F' + // (CJK) Ext C
        // '\\u2B740-\\u2B81F' + // (CJK) Ext D
        '\\uF900-\\uFAFF'   + // (CJK) Unified Compat
        '\\u3200-\\u32FF'   + // (CJK) Enclosed
        // specific list of chars used in nicks and chans:
        '#' + '[' + '\\\\' + '\\]' + '^' + '_' + '`' + '{' + '|' + '}' + '-' +
    ']+|(\\B:[^\\s:]+:?)', 'gi')
});


module.exports = TabCompletion;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/tabcompletion.js
// module id = TT07
// module chunks = 1